import { addEvents } from '../helpers/dom/addEvents';

class InputLabel {
	constructor(elem) {
		this.input = elem;
		this.setEvents();
		this.checkInput();
	}

	setEvents() {
		addEvents(this.input, ['keydown', 'keyup'], () => {
			this.checkInput(this.input);
		});
	}

	checkInput() {
		if (this.input.value.length > 0 || this.input.value !== this.input.defaultValue) {
			this.input.classList.add('is-active');
		} else {
			this.input.classList.remove('is-active');
		}
	}
}

export const inputLabels = () => {
	const inputs = document.querySelectorAll('.js-input');

	if (inputs.length > 0) {
		inputs.forEach((input) => {
			new InputLabel(input);
		});
	}
};

